/**
 * Enum de features do sistema
 */
export enum Feature {
  // Compartilhamento
  SHARE_DOCUMENTS = 'SHARE_DOCUMENTS',
  SHARED_DOCUMENTS_BY = 'SHARED_DOCUMENTS_BY',

  // Ofertas (Provider)
  SERVICE_OFFERING = 'SERVICE_OFFERING',        // Ofertas de consultas e procedimentos
  RESOURCE_OFFERING = 'RESOURCE_OFFERING',      // Ofertas de exames e terapias

  // Demandas (Contractor)
  SERVICE_DEMAND = 'SERVICE_DEMAND',            // Demandas de consultas e procedimentos
  RESOURCE_DEMAND = 'RESOURCE_DEMAND',          // Demandas de exames e terapias

  // Negociações
  NEGOTIATION = 'NEGOTIATION',

  // Pesquisas
  ADVANCED_SEARCH = 'ADVANCED_SEARCH',
  ADVANCED_SEARCH_OFFERS_SERVICE = 'ADVANCED_SEARCH_OFFERS_SERVICE',
  ADVANCED_SEARCH_OFFERS_RESOURCE = 'ADVANCED_SEARCH_OFFERS_RESOURCE',
  ADVANCED_SEARCH_DEMANDS_SERVICE = 'ADVANCED_SEARCH_DEMANDS_SERVICE',
  ADVANCED_SEARCH_DEMANDS_RESOURCE = 'ADVANCED_SEARCH_DEMANDS_RESOURCE',

  // Dashboard
  DASHBOARD_ACCESS = 'DASHBOARD_ACCESS',
}

/**
 * Configuração de features por PackageType
 * Define quais features cada tipo de pacote pode acessar
 */
export const PACKAGE_FEATURES_CONFIG: Record<string, Feature[]> = {
  // ========== PROVIDER PF ==========
  ['SUBSCRIPTION_PROVIDER_PF_FREE']: [
    Feature.DASHBOARD_ACCESS,
    Feature.SHARE_DOCUMENTS,
    Feature.NEGOTIATION,
  ],

  ['SUBSCRIPTION_PROVIDER_PF_BASIC']: [
    Feature.DASHBOARD_ACCESS,
    Feature.SHARE_DOCUMENTS,
    Feature.SERVICE_OFFERING,
    Feature.NEGOTIATION,
    Feature.ADVANCED_SEARCH,
    Feature.ADVANCED_SEARCH_OFFERS_RESOURCE,
    Feature.ADVANCED_SEARCH_DEMANDS_SERVICE,
  ],

  // ========== LAB ==========
  ['SUBSCRIPTION_LAB_FREE']: [
    Feature.DASHBOARD_ACCESS,
    Feature.SHARE_DOCUMENTS,
    Feature.NEGOTIATION,
  ],

  ['SUBSCRIPTION_LAB_BASIC']: [
    Feature.DASHBOARD_ACCESS,
    Feature.SHARE_DOCUMENTS,
    Feature.RESOURCE_OFFERING,
    Feature.NEGOTIATION,
    Feature.ADVANCED_SEARCH,
    Feature.ADVANCED_SEARCH_DEMANDS_RESOURCE,
  ],

  ['SUBSCRIPTION_LAB_PERSONAL']: [
    Feature.DASHBOARD_ACCESS,
    Feature.SHARE_DOCUMENTS,
    Feature.RESOURCE_OFFERING,
    Feature.NEGOTIATION,
    Feature.ADVANCED_SEARCH,
    Feature.ADVANCED_SEARCH_DEMANDS_RESOURCE,
  ],

  // ========== PROVIDER PJ ==========
  ['SUBSCRIPTION_PROVIDER_PJ_FREE']: [
    Feature.DASHBOARD_ACCESS,
    Feature.SHARE_DOCUMENTS,
    Feature.NEGOTIATION,
  ],

  ['SUBSCRIPTION_PROVIDER_PJ_2']: [
    Feature.DASHBOARD_ACCESS,
    Feature.SHARE_DOCUMENTS,
    Feature.SHARED_DOCUMENTS_BY,
    Feature.SERVICE_OFFERING,
    Feature.RESOURCE_OFFERING,
    Feature.NEGOTIATION,
    Feature.ADVANCED_SEARCH,
    Feature.ADVANCED_SEARCH_DEMANDS_SERVICE,
    Feature.ADVANCED_SEARCH_DEMANDS_RESOURCE,
  ],

  ['SUBSCRIPTION_PROVIDER_PJ_6']: [
    Feature.DASHBOARD_ACCESS,
    Feature.SHARE_DOCUMENTS,
    Feature.SHARED_DOCUMENTS_BY,
    Feature.SERVICE_OFFERING,
    Feature.RESOURCE_OFFERING,
    Feature.NEGOTIATION,
    Feature.ADVANCED_SEARCH,
    Feature.ADVANCED_SEARCH_DEMANDS_SERVICE,
    Feature.ADVANCED_SEARCH_DEMANDS_RESOURCE,
  ],

  ['SUBSCRIPTION_PROVIDER_PJ_10']: [
    Feature.DASHBOARD_ACCESS,
    Feature.SHARE_DOCUMENTS,
    Feature.SHARED_DOCUMENTS_BY,
    Feature.SERVICE_OFFERING,
    Feature.RESOURCE_OFFERING,
    Feature.NEGOTIATION,
    Feature.ADVANCED_SEARCH,
    Feature.ADVANCED_SEARCH_DEMANDS_SERVICE,
    Feature.ADVANCED_SEARCH_DEMANDS_RESOURCE,
  ],

  ['SUBSCRIPTION_PROVIDER_PJ_PERSONAL']: [
    Feature.DASHBOARD_ACCESS,
    Feature.SHARE_DOCUMENTS,
    Feature.SHARED_DOCUMENTS_BY,
    Feature.SERVICE_OFFERING,
    Feature.RESOURCE_OFFERING,
    Feature.NEGOTIATION,
    Feature.ADVANCED_SEARCH,
    Feature.ADVANCED_SEARCH_DEMANDS_SERVICE,
    Feature.ADVANCED_SEARCH_DEMANDS_RESOURCE,
  ],

  // ========== PROVIDER + CONTRACTOR PJ ==========
  ['SUBSCRIPTION_PROVIDER_CONTRACTOR_PJ_FREE']: [
    Feature.DASHBOARD_ACCESS,
    Feature.SHARE_DOCUMENTS,
    Feature.NEGOTIATION,
  ],

  ['SUBSCRIPTION_PROVIDER_CONTRACTOR_PJ_100']: [
    Feature.DASHBOARD_ACCESS,
    Feature.SHARE_DOCUMENTS,
    Feature.SHARED_DOCUMENTS_BY,
    Feature.SERVICE_OFFERING,
    Feature.RESOURCE_OFFERING,
    Feature.SERVICE_DEMAND,
    Feature.RESOURCE_DEMAND,
    Feature.NEGOTIATION,
    Feature.ADVANCED_SEARCH,
    Feature.ADVANCED_SEARCH_OFFERS_SERVICE,
    Feature.ADVANCED_SEARCH_OFFERS_RESOURCE,
    Feature.ADVANCED_SEARCH_DEMANDS_SERVICE,
    Feature.ADVANCED_SEARCH_DEMANDS_RESOURCE,
  ],

  ['SUBSCRIPTION_PROVIDER_CONTRACTOR_PJ_PERSONAL']: [
    Feature.DASHBOARD_ACCESS,
    Feature.SHARE_DOCUMENTS,
    Feature.SHARED_DOCUMENTS_BY,
    Feature.SERVICE_OFFERING,
    Feature.RESOURCE_OFFERING,
    Feature.SERVICE_DEMAND,
    Feature.RESOURCE_DEMAND,
    Feature.NEGOTIATION,
    Feature.ADVANCED_SEARCH,
    Feature.ADVANCED_SEARCH_OFFERS_SERVICE,
    Feature.ADVANCED_SEARCH_OFFERS_RESOURCE,
    Feature.ADVANCED_SEARCH_DEMANDS_SERVICE,
    Feature.ADVANCED_SEARCH_DEMANDS_RESOURCE,
  ],


  ['SUBSCRIPTION_CONTRACTOR_PJ_120']: [
    Feature.DASHBOARD_ACCESS,
    Feature.SHARE_DOCUMENTS,
    Feature.SHARED_DOCUMENTS_BY,
    Feature.SERVICE_DEMAND,
    Feature.RESOURCE_DEMAND,
    Feature.NEGOTIATION,
    Feature.ADVANCED_SEARCH,
    Feature.ADVANCED_SEARCH_OFFERS_SERVICE,
    Feature.ADVANCED_SEARCH_OFFERS_RESOURCE,
  ],

  ['SUBSCRIPTION_CONTRACTOR_PJ_PERSONAL']: [
    Feature.DASHBOARD_ACCESS,
    Feature.SHARE_DOCUMENTS,
    Feature.SHARED_DOCUMENTS_BY,
    Feature.SERVICE_DEMAND,
    Feature.RESOURCE_DEMAND,
    Feature.NEGOTIATION,
    Feature.ADVANCED_SEARCH,
    Feature.ADVANCED_SEARCH_OFFERS_SERVICE,
    Feature.ADVANCED_SEARCH_OFFERS_RESOURCE,
  ],

  // ========== ADMINISTRATOR ==========
  ['SUBSCRIPTION_ADMINISTRATOR']: [
    Feature.DASHBOARD_ACCESS,
    Feature.SHARE_DOCUMENTS,
  ],
};

/**
 * Helper para verificar se um packageType tem acesso a uma feature
 */
export function hasFeature(packageType: string | undefined | null, feature: Feature): boolean {
  if (!packageType) return false;
  const features = PACKAGE_FEATURES_CONFIG[packageType];
  if (!features) return false;

  return features.includes(feature);
}

/**
 * Helper para verificar se um packageType tem acesso a QUALQUER uma das features
 */
export function hasAnyFeature(packageType: string | undefined | null, features: Feature[]): boolean {
  if (!packageType || features.length === 0) return false;

  return features.some(feature => hasFeature(packageType, feature));
}

/**
 * Helper para verificar se um packageType tem acesso a TODAS as features
 */
export function hasAllFeatures(packageType: string | undefined | null, features: Feature[]): boolean {
  if (!packageType || features.length === 0) return false;

  return features.every(feature => hasFeature(packageType, feature));
}

/**
 * Retorna todas as features disponíveis para um packageType
 */
export function getAvailableFeatures(packageType: string | undefined | null): Feature[] {
  if (!packageType) return [];

  return PACKAGE_FEATURES_CONFIG[packageType] || [];
}

/**
 * Verifica se o packageType é FREE (não pode fazer pesquisas avançadas)
 */
export function isFreePackage(packageType: string | undefined | null): boolean {
  if (!packageType) return false;
  return packageType.includes('FREE');
}

/**
 * Verifica se o packageType é ADMINISTRATOR (não pode fazer pesquisas)
 */
export function isAdministratorPackage(packageType: string | undefined | null): boolean {
  if (!packageType) return false;
  return packageType === 'SUBSCRIPTION_ADMINISTRATOR';
}
